<div class="login-logs">
  <div class="header">
    <h2>Login Logs</h2>
  </div>

  <div class="filters">
    <div class="filter-group">
      <label>Client:</label>
      <select [(ngModel)]="selectedClientId" (change)="onClientChange()">
        <option [ngValue]="null">All Clients</option>
        <option *ngFor="let client of clients" [ngValue]="client.clientParamID">
          {{ client.clientName }}
        </option>
      </select>
    </div>

    <div class="filter-group">
      <label>User:</label>
      <select [(ngModel)]="selectedUserId" (change)="onUserChange()" [disabled]="!selectedClientId">
        <option [ngValue]="null">All Users</option>
        <option *ngFor="let user of users" [ngValue]="user.clientUserID">
          {{ user.email }}
        </option>
      </select>
    </div>

    <div class="filter-group">
      <label>Status:</label>
      <select [(ngModel)]="selectedStatus" (change)="onStatusChange()">
        <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="error" class="error-message">{{ error }}</div>
  <div *ngIf="loading" class="loading">Loading...</div>

  <div *ngIf="!loading && loginAttempts.length === 0" class="no-data">
    No login attempts found
  </div>

  <table *ngIf="!loading && loginAttempts.length > 0" class="data-table">
    <thead>
      <tr>
        <th>Date/Time</th>
        <th>Email</th>
        <th>User</th>
        <th>Client</th>
        <th>Status</th>
        <th>IP Address</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let attempt of loginAttempts">
        <td>{{ attempt.attemptedAt | date:'medium' }}</td>
        <td>{{ attempt.email }}</td>
        <td>{{ attempt.userName || 'N/A' }}</td>
        <td>{{ attempt.clientName || 'N/A' }}</td>
        <td>
          <span class="login-status" [ngClass]="getStatusClass(attempt.status)">
            {{ getStatusLabel(attempt.status) }}
          </span>
        </td>
        <td>{{ attempt.ipAddress || 'N/A' }}</td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="totalPages > 1" class="pagination">
    <button class="btn btn-sm" (click)="goToPage(1)" [disabled]="currentPage === 1">
      « First
    </button>
    <button class="btn btn-sm" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
      ‹ Prev
    </button>

    <span *ngFor="let page of getPageNumbers()">
      <button
        class="btn btn-sm"
        [class.active]="page === currentPage"
        (click)="goToPage(page)">
        {{ page }}
      </button>
    </span>

    <button class="btn btn-sm" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
      Next ›
    </button>
    <button class="btn btn-sm" (click)="goToPage(totalPages)" [disabled]="currentPage === totalPages">
      Last »
    </button>

    <span class="page-info">
      Page {{ currentPage }} of {{ totalPages }} ({{ totalCount }} total)
    </span>
  </div>
</div>

